<template>
  <ModalDialog
    ref="dialog"
    title="Edit Contact Despatch"
    :submitting="submitting"
    submitTitle="Update"
    icon="fa-truck"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="contactForm" :labelColumnSize="3">

      <FormRow label="Default Despatch Task Type" helpTip="The default task type selected for new orders for this contact to be used for order despatching">
        <TaskTypeSelect v-model="contact.defaultDespatchTaskTypeId" />
      </FormRow>

      <FormRow label="Default Despatch Fees" helpTip="The default fee stock items for the different task types when used for order despatch. If not set, uses system defaults per task type">
        <TaskTypeContactDefaultStock v-model="contact.contactTaskTypeDefaultStocks" />
      </FormRow>

      <FormHorizontalRule />
      <FormRow label="Pickup - Full Self Serve Enabled" helpTip="If enabled, the contact will get full self-service access for pickups on the kiosk. This includes the ability to load additional orders not in the original pickup">
        <FormCheckbox v-model="contact.isPickupFullSelfServeEnabled" field="isPickupFullSelfServeEnabled" />
      </FormRow>

    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import TaskTypeContactDefaultStock from '@/modules/tasks/components/taskTypeContactDefaultStock'
import TaskTypeSelect from '@/modules/tasks/components/taskTypeSelect'

export default {
  name: "ContactEditDespatchDialog",
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
    TaskTypeContactDefaultStock,
    TaskTypeSelect
  },
  props: {
    contactId: Number,
    isCreateMode: Boolean
  },
  data() {
    return {
      contact: {
        defaultDespatchTaskTypeId: null,
        defaultDeliveryStockId: null,
        isPickupFullSelfServeEnabled: false,
        contactTaskTypeDefaultStocks: []
      },
      contactForm: {},
      submitting: false
    }
  },
  created() {
  },
  mounted() {
    
  },
  computed: {
  },
  methods: {
    show(contact) {
      // Reset form
      this.contact = { }
      this.contactForm = {}
      this.submitting = false

      if(contact != null) {
        this.contact = _.cloneDeep(contact)
      }

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var contactData = _.cloneDeep(this.$data.contact)
      var updateData = _.pick(contactData, ['defaultDespatchTaskTypeId', 'defaultDeliveryStockId', 'isPickupFullSelfServeEnabled', 'contactTaskTypeDefaultStocks'])

      this.$apiService.contactService.updateContact(this.contactId, updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.contactForm = this.processFormResponse(err)
        })
    }
  }
}
</script>